import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Button from '../button.js';
import Copy from '../copy.js';
import Text from '../text.js';
import Icon from '../icon.js';
import NumberFormat from 'react-number-format';
import CarrotDown from '../icons/actions/carrot-down.js';
export const HelperIcon = styled(Icon).withConfig({ displayName: "brc-HelperIcon", componentId: "brc-1gi02qz" }) `
  max-width: 16px;
  max-height: 16px;
  fill: ${({ theme }) => theme.neutral400};
`;
// TODO: I think the `size` prop isn't used and is overwritten in attrs
export const HelperDescription = styled(Copy).attrs(() => ({ size: 'sm', bold: true })).withConfig({ displayName: "brc-HelperDescription", componentId: "brc-8uzwh6" }) `
  color: inherit;
`;
// TODO: hasSpaceForHelper is unused and might be a mistake
export const HelperItem = styled.div.attrs(({ isLink }) => isLink && { as: Button, variation: 'buttonLink', type: 'button' }).withConfig({ displayName: "brc-HelperItem", componentId: "brc-kpw0zl" }) `
  display: grid;
  padding-top: 4px;
  grid-template-columns: min-content 1fr;
  grid-gap: 4px;
  text-align: left;
  ${({ hasSpaceForErrors }) => (hasSpaceForErrors ? 'min-height: 18px;' : '')}
  ${({ theme, isLink }) => !isLink && `color: ${theme.neutral400};`}
`;
export const Helper = styled(({ className, hasSpaceForHelper, helperLinkAction, helperText, iconName }) => (_jsxs(HelperItem, Object.assign({ className: className, isLink: !!helperLinkAction, onClick: helperLinkAction, hasSpaceForHelper: hasSpaceForHelper }, { children: [iconName && _jsx(HelperIcon, { name: iconName }), _jsx(HelperDescription, Object.assign({ "data-testid": `input:helper-text:${helperText}`, light: true, size: "xs" }, { children: helperText }))] })))).withConfig({ displayName: "brc-Helper", componentId: "brc-1xkbmh4" }) ``;
export const Label = styled(Text).withConfig({ displayName: "brc-Label", componentId: "brc-1r7266h" }) `
  display: block;
  transition: all 0.2s linear;
  pointer-events: none;
  transform-origin: 0 0;

  &:focus {
    outline: none;
  }

  &::after {
    content: '${({ required }) => (required ? '*' : '')}';
    font-size: 24px;
  }
`;
export const FieldWrapper = styled.div.withConfig({ displayName: "brc-FieldWrapper", componentId: "brc-1hiac4g" }) `
  display: grid;

  & > ${Copy} {
    margin-bottom: ${({ theme }) => theme.gu(1)};
  }

  & * {
    font-family: inherit;
  }

  & > ${Label} {
    font-size: 14px;
  }

  & > ${Helper} {
    margin-left: ${({ theme }) => theme.gu(2)};
  }
`;
FieldWrapper.displayName = 'FieldWrapper';
export const Input = styled.input.withConfig({
    shouldForwardProp: (prop) => !['isInvalid', 'hasSpaceForErrors'].includes(prop),
}) `
  width: 100%;
  border-width: 3px;
  border-style: solid;
  border-color: ${({ isInvalid, theme }) => (isInvalid ? theme.transparentRed : theme.bubbleBlue200)};
  border-radius: 12px;
  font-weight: bold;
  background: ${({ isInvalid, theme }) => (isInvalid ? theme.sebastianRed100 : theme.bubbleBlue100)};
  ${({ disabled, theme }) => disabled && `cursor: not-allowed; background: ${theme.scuttleGray100}`};
  padding: ${({ theme }) => `${theme.gu(3)} ${theme.gu(2)} ${theme.gu(1)} ${theme.gu(2)}`};

  &:focus,
  &:hover {
    outline: none;
    outline-offset: 0;
  }

  &:focus {
    border-color: ${({ theme }) => theme.bubbleBlue300};
  }
`;
export const CurrencyInput = styled(Input).attrs(() => ({
    as: NumberFormat,
})).withConfig({ displayName: "brc-CurrencyInput", componentId: "brc-oszxwb" }) ``;
export const PercentInput = styled(Input).attrs(() => ({ as: NumberFormat })).withConfig({ displayName: "brc-PercentInput", componentId: "brc-f6ajlf" }) ``;
export const NumberInput = styled(Input).attrs(() => ({ as: NumberFormat })).withConfig({ displayName: "brc-NumberInput", componentId: "brc-1am9n1v" }) ``;
const ChevronWrapper = styled.div.withConfig({ displayName: "brc-ChevronWrapper", componentId: "brc-hk74vx" }) `
  pointer-events: none;
  & > ${Icon} {
    fill: ${({ isInvalid, disabled, theme }) => isInvalid ? theme.error : disabled ? theme.scuttleGray500 : theme.azure};
  }
`;
export const Chevron = styled(({ className, disabled, isInvalid }) => (_jsx(ChevronWrapper, Object.assign({ className: className, disabled: disabled, isInvalid: isInvalid }, { children: _jsx(CarrotDown, {}) })))).withConfig({ displayName: "brc-Chevron", componentId: "brc-dg0jlc" }) ``;
export const Field = styled.label.withConfig({ displayName: "brc-Field", componentId: "brc-1l3h3nz" }) `
  align-items: stretch;
  color: ${({ theme }) => theme.scuttleGray600};
  cursor: pointer;
  display: flex;
  flex: 1 1 auto;
  margin-bottom: 0;
  overflow: hidden;
  position: relative;
  text-align: left;
  white-space: nowrap;

  & > * {
    width: 100%;
    border-radius: 12px;
    appearance: none;
  }

  & > ${Label} {
    will-change: transform;
    font-weight: ${({ isVisited }) => (isVisited ? 'normal' : 'bold')};
    top: ${({ isVisited, theme }) => (isVisited ? theme.gu(1) : theme.gu(2))};
    transform: ${({ isVisited }) => (isVisited ? 'scale(0.75)' : 'scale(1)')};
    left: ${({ theme }) => theme.gu(2)};
    position: absolute;
    transition: all 0.2s ease;
    color: ${({ theme }) => theme.scuttleGray600};
  }

  * {
    font-size: 16px;
  }

  ${Input}:focus ~ ${Label}, &:hover ${Label}, &:active ${Label} {
    transform: scale(0.75);
    font-weight: normal;
    top: ${({ theme }) => theme.gu(1)};
  }

  ${CurrencyInput}:focus + ${Label},
  &:hover ${Label},
  &:active ${Label} {
    color: ${({ theme }) => theme.scuttleGray600};
  }

  & > ${Chevron} {
    width: min-content;
    position: absolute;
    right: 16px;
    top: 16px;
  }
`;
export const Err = styled(Copy).attrs(() => ({ size: 'sm', bold: true })).withConfig({ displayName: "brc-Err", componentId: "brc-2ww3kz" }) `
  color: ${({ theme }) => theme.error};
  text-align: left;
`;
export const Errors = styled.div.withConfig({ displayName: "brc-Errors", componentId: "brc-78ajsr" }) `
  ${({ hasSpaceForErrors }) => (hasSpaceForErrors ? 'min-height: 18px;' : '')}

  & > ${Err} {
    margin-left: ${({ theme }) => theme.gu(2)};
  }
`;
//# sourceMappingURL=shared.js.map